export enum PeerStateEnum {
  UNREGISTERED = 'UNREGISTERED',
  REGISTERED = 'REGISTERED'
}
